/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  document.addEventListener('click', function(event) {
  var link = event.target.closest('.mobile-menu__item--has-items > .mobile-navlink--level-1');

  if (!link) return;

  event.preventDefault();

  var item = link.closest('.mobile-menu__item--has-items');
  var trigger = item ? item.querySelector('.mobile-nav__trigger--level-1') : null;

  if (trigger) {
    trigger.click();
  }
});







  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
